<template>
	<div class="my-table applicationPage">
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('PlatformMonitoringList.txt1')}}</span>
        <span>{{$t('PlatformMonitoringList.txt2')}}/{{$t('PlatformMonitoringList.txt3')}}</span>
      </div>
    </div>
		<!-- 面包屑 -->
			<div class="projectCost">
				<div class="container">
					<div class="wrapper" v-for="(item,index) in list" :key="index">
						<div class="header">
							<span>{{$t('PlatformMonitoringList.txt4')}}{{item.hostname}}</span>
							<!-- <img width="15" height="16" src="@/assets/picture/icon/delete_S_icon.png"/> -->
						</div>
						<div class="roseChart">
              <Chart :chartData="item"></Chart>
            </div> 
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import { formatDate } from "@/plugins/date.js";
import Chart from "./Chart";
import qs from "qs";
export default {
	components: {
		Chart,
	},
	data() {
		return {
			time: "",
			//用于获取数据列表
			queryInfo: {
				name: "",
				type: "",
			},
			list: [
				// 假数据
			],
		};
	},
	mounted() {
		this.loadData();
	},
	filters: {
		formatDate(time) {
			var date = new Date(time);
			return formatDate(date, "yyyy-MM-dd");
		},
	},
	methods: {
		// 数据加载(查询app)
		async loadData() {
			const { data: res } = await this.$http.post("/monitor/data");
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.list = res.result;
      // this.timer = setTimeout(() => {
      //   this.loadData()
      // }, 5000)
		},
	},
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  }
};
</script>

<style lang="less" scoped>
  .applicationPage{
    .w32{
       /deep/ .el-input,/deep/ .el-input__inner{
         width: 100% !important;
       }
     }
    .searchBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      .btnC{
        padding:0.6rem 2.6rem;
      }
    }
    /deep/ .el-transfer__button:first-of-type{
      display: none;
    }
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    /deep/ .el-transfer-panel{ 
      border: 1px solid #C0C0C0;
      border-radius: 6px;
      width: 46%;
      margin-right: 0.8rem;
    }
    /deep/ .el-transfer-panel:last-of-type{
      margin-left: 0.8rem;
      margin-right: 0rem;
    }
    /deep/ .el-transfer-panel .el-transfer-panel__header{
      background: #EEEEEE; 
      font-size: 1.4rem;
      font-weight: bold;
      color: #1B3B7C;
    }
    /deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{
      font-size: 1.4rem;
      font-weight: bold;
      color: #1B3B7C;
    }
    /deep/ .el-button+.el-button{
      margin-left: 0 !important;
    }
    /deep/ .el-transfer__buttons{
      padding:0;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
  }
  .projectCost{
   .container{
    /*display: flex;*/
    width: 100%;
    min-height: 100%;
    background-size: 100% 100%;
    .wrapper:nth-child(odd){
      margin-right: 5rem;
      margin-bottom: 5rem;
    }
    .wrapper{
      margin-top: 5rem;
      width: 100%;
      height: 45em;
      background: #FFFFFF;
      border: 0px solid #F4F4F4;
      box-shadow: 0rem 0rem 2rem 0rem rgba(202, 204, 204, 0.3);
      border-radius: 3rem;
      float:left;
      .header{
        padding:2.5rem 0;
        margin:0 2rem;
        span{
          font-size: 1.4rem;
          color: #333;
        }
        img{
          float: right;
          height: 1.6rem;
          width: 1.5rem;
        }
      }
      .roseChart{
        width: 100%;
        height:100%;
       /* /deep/ div{
          width: 100% !important;
        }*/
        /deep/ canvas{
          height: 50rem !important;
          width: 100% !important;
          margin: 0 auto;
          display: block;
          left: 50%;
        }
     }
    }
    .wrapper:nth-of-type(1),.wrapper:nth-of-type(2){
      margin-top: 0rem;
    }
   }
  }
</style>
